import React from 'react'
import { connect } from 'react-redux'
import { EInspectionPermissions } from '@Enum/auth.enum'
import InspectionLayout from '@Layouts/Inspection/InspectionLayout'

import { Route, Redirect } from 'react-router-dom'

interface InspectionRoute {
    exact?: boolean
    path?: string
    user?: any
    component: any
}

const InspectionRoute: React.FC<InspectionRoute> = ({
    component: Component,
    user,
    exact,
    path,
}) => {
    return (
        <Route
            exact={exact}
            path={path}
            render={(props: any) => {
                if (
                    user?.permissions?.includes(EInspectionPermissions?.LOGIN)
                ) {
                    return (
                        <InspectionLayout>
                            <Component {...props} />{' '}
                        </InspectionLayout>
                    )
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => {
    const { user } = state?.auth

    return {
        user,
    }
}

export default connect(mapStateToProps, null)(InspectionRoute)
